<div class="row" data-testid="home-div">
  <hr />
  <div class="col-md-8">
    <div class="panel panel-primary" id="panelLatestMovies">
      <div class="panel-heading">
        <h3 class="panel-title">Active Strikes</h3>
      </div>
      <div class="panel-body">
        <div *ngIf="loadingStrikes">
          <div class="col-xs-4"></div>
          <div class="col-xs-4">
            <i class="fa fa-refresh fa-5x fa-spin"></i> <span class="label label-primary">Loading strikes...</span>
          </div>
          <div class="col-xs-4"></div>
        </div>
        <div *ngIf="!loadingStrikes && !currentStrikes.length">
          <b>No active strikes</b>
        </div>
        <div class="panel-body" *ngIf="currentStrikes.length">
          <div class="col-xs-12 col-sm-6 movie" *ngFor="let strike of currentStrikes">
            <div class="panel panel-default">
              <div class="panel-heading">
                <a routerLink="/strikes/{{strike.ID}}" title="View {{strike.Title}} details" [attr.data-testid]="'home-strike-' + strike.Title" ><strong>{{strike.Title}} </strong>  </a>
              </div>
              <div class="panel-body"  [attr.data-testid]="'home-start-date-' + strike.ID">
                <div class="media">
                  Start Date: <strong>{{strike.StartDate | date:"MM/dd/yyyy"}}</strong>
                  <div *ngIf="strike.EndDate !== null">
                    <br />
                    Ended Date: <strong>{{strike.EndDate | date:"MM/dd/yyyy"}}</strong>
                  </div>
                </div>
              </div>
              <div class="panel-footer" [attr.data-testid]="'home-strike-info-' + strike.ID">
                Min Threshold Time(in Hours): {{strike.MinThresholdHours}}
                <br />
                Min Threshold Days: {{strike.MinThresholdDays}}
                <br />
                Participation Benefit Amount: {{strike.ParticipationBenefitAmt | currency:'USD':'symbol':'1.0-0'}}
                <br />
                Helper Benefit Amount : {{strike.HelperBenefitAmt | currency:'USD':'symbol':'1.0-0'}}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

